import { gql } from 'apollo-angular';

export const PERMISSION_INFO_FRAGMENT = gql`
  fragment PermissionInfo on Permission {
    id
    value
  }
`;
